import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { IconButton, Stack, Typography } from "@mui/material";
import { BybRewardSticker } from "../byb-reward-sticker";
import { IBybRewardListItemVariant } from "./byb-reward-list-item";

const BybRewardListItemCompact = ({
  name,
  scarcity,
  color,
  achieved = false,
  handleClick,
}: IBybRewardListItemVariant) => {
  return (
    <Stack sx={{ textAlign: "center" }}>
      <HapticsButtonWrapper>
        <IconButton
          onClick={handleClick}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          sx={{
            ...(!achieved ? { filter: "grayscale(100%)", opacity: 0.5 } : {}),
            transition: "opacity 0.2s",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          <BybRewardSticker scarcity={scarcity} color={color} />
        </IconButton>
      </HapticsButtonWrapper>
      <Typography variant="textXs500" color="dsNeutral.v300">
        {name}
      </Typography>
    </Stack>
  );
};

export default BybRewardListItemCompact;
